import styled, { css } from "styled-components";
import { stylesGlobalDefault } from "../../../../global/globalStyle";

interface IContainerInput {
  error?: boolean;
}

export const BottomContainer = styled.div`
  width: 100%;
  align-items: flex-start;
  margin-top: 20px;
`;

export const KeyWordsTitle = styled.span`
  font-size: 16px;
  font-family: "Inter";
  font-weight: 600;
  line-height: 0.36px;
`;

export const ContainerCheckboxList = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;

  .MuiFormControlLabel-root {
    pointer-events: none;
  }

  .MuiFormControlLabel-root input[type="checkbox"] {
    pointer-events: auto;
  }
`;

export const ContainerTextEditor = styled.div<IContainerInput>`
  border: 2px solid ${stylesGlobalDefault.inputsBorderFocusOff};

  ${(props) =>
    props.error &&
    css`
      border: 2px solid ${stylesGlobalDefault.inputsBorderFocusError};
    `}
  width: 100%;
  border-radius: 10px;
`;

export const ContainerBody = styled.div`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 0 33px;
  padding-bottom: 50px;
`;

export const ContentInputTitle = styled.div`
  display: flex;
  margin-bottom: 27px;
  width: 47%;
`;
export const ContentInputDescription = styled.div`
  margin-bottom: 10px;
`;
